import React from 'react'
import { Container, HelpButtonCont } from './styles'
import { BiHelpCircle } from 'react-icons/bi'
import { Link } from 'react-router-dom'

const HelpButton: React.FC = () => {
  return (
    <Container>
      <Link to="/config/help">
        <HelpButtonCont>
          <BiHelpCircle size="18px" className="IconButton" /> Ajuda
        </HelpButtonCont>
      </Link>
    </Container>
  )
}

export default HelpButton
